module.exports = __webpack_public_path__ + "img/MARRIOTT LANAI.6598be8b.png";